export default [
  {
    nome: "Pineta Grande",
    codice: "150901"
  },
  {
    nome: "Sanatrix",
    codice: "150907"
  }
]